import cx from 'classnames';

export const getFormElementGroupStylesAsClassName = (): string => {
  return cx(
    'flex',
    '[&>*:not(:first-of-type):not(:last-child)]:rounded-none',
    '[&>*:first-of-type:not(:last-child)]:rounded-r-none',
    '[&>*:last-child]:rounded-l-none'
  );
};
